var _path, _path2, _g, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComplexType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 148,
    viewBox: "0 0 279 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.839 36.7791C174.907 54.9943 190.376 78.2476 201.028 95.9954C205.064 102.721 204.615 111.289 198.896 116.657C186.464 128.326 165.197 141.358 139.627 138.163C132.56 137.28 126.186 136.447 120.425 135.695C92.4159 132.035 78.9168 130.272 70.875 133.849C61.1791 138.163 -10.2174 126.948 1.24127 100.204C2.26725 96.6892 25.088 63.6607 52.8488 38.0232C53.4854 22.643 103.235 0.454431 114.068 0.454407C134.952 -3.87055 155.044 23.7759 157.839 36.7791Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.481 7.25383C67.1928 0.583307 3.53326 90.6358 1.83567 96.4725C-9.19864 122.321 59.5536 133.16 68.8904 128.991C78.2271 124.822 95.203 128.157 135.096 133.16C159.518 136.223 179.864 123.857 191.875 112.651C197.592 107.316 198.037 98.7715 194.018 92.0638C175.242 60.7221 141.173 11.9832 110.481 7.25383Z",
    fill: "#7FAD8F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_183_1138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.6823 26.4636C67.6857 16.86 87.7291 7.06369 100.629 2.73489C107.087 0.567452 114.137 -0.939976 120.731 0.770902C137.898 5.22468 152.344 27.7978 153.057 37.3859C153.906 48.8221 144.561 50.5816 139.464 43.5439C135.386 37.9137 132.667 41.7844 131.818 44.4236C130.968 47.9424 127.91 54.9801 122.473 54.9801C115.676 54.9801 114.281 46.1655 113.977 43.5439C113.68 40.982 108.03 34.7467 106.331 43.5439C106.088 44.8019 105.751 46.0224 105.35 47.1904C102.501 55.4869 93.7385 65.2439 86.2692 60.6439C83.4603 58.9139 82.544 55.153 82.544 52.341C84.5829 35.4505 81.6944 33.5738 79.9953 34.7467C74.393 37.8705 69.7242 39.7209 65.8971 40.7073C56.4655 43.1383 50.6562 33.2089 57.6823 26.4636Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5264 65.9447C74.9599 77.656 63.2905 89.4239 75.5264 97.4544M68.3623 53.9554C59.2987 59.8111 39.9818 76.7088 35.2234 97.4544",
    stroke: "#667D6A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.955 54.2617C176.292 49.3141 125.316 116.108 123.957 120.437C115.121 139.609 170.175 147.649 177.651 144.556C185.127 141.464 198.721 143.938 230.665 147.649C248.259 149.692 263.211 142.473 273.038 134.952C279.653 129.888 280.181 120.64 275.575 113.699C260.172 90.4907 234.339 57.5994 210.955 54.2617Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M208.221 46.4902C174.78 41.337 125.601 110.905 124.289 115.414C115.765 135.383 168.878 143.757 176.091 140.536C183.304 137.315 196.418 139.892 227.237 143.757C244.698 145.946 259.463 137.926 268.921 129.856C274.87 124.781 275.317 116.185 271.246 109.51C256.475 85.2901 231.13 50.0203 208.221 46.4902Z",
    fill: "#7FAD8F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M241.293 76.4403C243.298 84.6189 249.545 102.777 258.49 109.98M223.826 77.5502C221.953 86.4123 220.294 106.044 228.638 113.674M189.449 68.0771C181.816 71.4279 165.005 81.9387 158.823 97.1754",
    stroke: "#667D6A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_183_1138",
    x: 50.5739,
    y: 0.0310059,
    width: 106.537,
    height: 69.7938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_183_1138"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_183_1138",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplexType);
export default __webpack_public_path__ + "static/media/complex_type.95294cf9a69ec61779b3e2b2f4275c61.svg";
export { ForwardRef as ReactComponent };